export default "/images/21c7b6878df312658bb0a6e30a533b81.png";